import { Account } from './account.model';
import { Element } from './element.model';
import { Location } from './location.model';
import { ComponentRecords } from './nitel-component.model';
import { Order } from './order.model';
import { SalesforceBase } from './salesforce-base.model';
import { User } from './user.model';

export interface Vendor {
  Id: string;
  Name: string;
  Display_Alias__c?: string;
}

export interface Service extends SalesforceBase {
  Account__r?: Account;
  Activation_Date__c?: Date;
  Activation_Pending__c?: boolean;
  alias: any;
  Asymmetrical_Bandwidth__c?: boolean;
  Bandwidth_Downstream__c?: string;
  Bandwidth_Text__c?: string;
  Bandwidth_Upstream__c?: string;
  BanLookupId?: string;
  Booked_MRM__c?: number;
  Clean_Order_Date__c?: Date;
  Components__r?: ComponentRecords;
  Connector_Type_Z_Location__c?: string;
  Current_Term_End_Date__c?: Date;
  CustomerLocationAlias?: string;
  Elements__r?: Element[];
  End_Of_Service__c?: Date;
  First_Invoice__c?: Date;
  localContacts?: string;
  MRR__c?: number;
  Name?: string;
  Orders__r: Order[];
  Partner__r?: SalesforceBase;
  Partner_MRC__c?: number;
  Partner_MRC_Percentage__c?: number;
  Partner_Or_Subagent_Rep__r?: User;
  RecordType?: SalesforceBase;
  Sales_Rep__r?: User;
  Start_Of_Service__c?: Date;
  Status__c?: string;
  Term__c?: string;
  Transport_Type__c: string;
  TSP_Code__c?: string;
  Vendor__r?: Vendor;
  Z_Location__c?: string;
  Z_Location__r?: Location;
  Z_Location_Company_Name__c?: string;
  Z_Location_Customer_Side_Id__c?: string;
}

export interface MappedService {
  alias?: string;
  bandwidth?: string;
  disabled: boolean;
  id: string;
  locationId: string;
  locationName: string;
  nit: string;
  product: string;
}

export enum ServiceStatus {
  Canceled = 'Canceled',
  Disconnected = 'Disconnected',
  InService = 'InService',
  New = 'New',
}

export const ServiceSelectMode = {
  Disconnect: 'disconnect',
  Transfer: 'transfer',
} as const;

export type ServiceSelectModeType =
  (typeof ServiceSelectMode)[keyof typeof ServiceSelectMode];
